import React, { useState } from 'react'

import { StyleSheet, Keyboard, Platform, View, Image } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import client, { authenticationHelper } from '@sart/client'
import { prettyErrorMessage, testID } from '@sart/utilities'
import { adaptive, backgroundColors, typography, colors } from '@sart/styles'
import { useContent } from '@sart/content'

import AppConfig from '../Configuration'
import ApiClient from "../bff-client/src/ApiClient";
import CustomersApi from "../bff-client/src/api/CustomersApi";
import EmailApi from "../bff-client/src/api/EmailApi";

import {
  Title,
  Description,
  Space,
  Anchor,
  Button,
  TextInputExtended,
  KeyboardAvoidingView,
  ReturnFooter
} from '@sart/components'
import { GuruFullBodyCallMe, CompanyIcon } from '@sart/icons'

import NeedHelpFooter from '../NeedHelpFooter'
import * as theme from './signTheme'
import { register } from 'numeral'

export default function SignUpVerifyNumber(props) {
  const content = useContent()

  const [resendingCode, setResendingCode] = useState(false)

  const { navigation, route } = props

  const bffClient = new ApiClient(AppConfig.bffBasePath)
  bffClient.defaultHeaders = {
    ...bffClient.defaultHeaders,
    Origin: AppConfig.shopOriginUrl
  }
  const customersApi = new CustomersApi(bffClient)
  const emailApi = new EmailApi(bffClient);

  const email = route.params?.email
  console.log('email is: ' + email)
  const ncaFlow = route.params?.ncaFlow

  const formik = useFormik({
    initialValues: {
      code: ''
    },
    validationSchema: Yup.object().shape({
      code: Yup.string().trim().required('Required')
    }),
    onSubmit: handleCodeVerification
  })

  async function handleResendCode(values, form) {
    setResendingCode(true)
    Keyboard.dismiss()

    try {
      // Call the API to send OTP
      emailApi.emailVerifyPost({ email: email });
    } catch (error) {
      const message = prettyErrorMessage(error, 'registration', content)

      form.setFieldError('code', message)
    }
    setResendingCode(false)
  }

  async function handleCodeVerification({ code }, form) {
    Keyboard.dismiss()
    form.setSubmitting(true)

    try {
      const validationResp = await emailApi.emailVerifyPost({ email: email, code: code, register: true });

      const subscriptionInfoResp = await customersApi.customersSubscriptionsPendingGet(email)

      console.log('subscriptionInfoResp is: ' + JSON.stringify(subscriptionInfoResp, null, 2))

      const params = { email: email, number: subscriptionInfoResp.iccid, ncaFlow: false }
      navigation.navigate('SetPassword', params)

    } catch (error) {
      console.log('error is: ');
      console.log(error);

      let message = "";
      console.log('error.error is: ' + error.body.error);

      if (error?.body?.error === "Invalid code") {
        message = content.forms.verificationCodeInvalid
      } else {
        message = prettyErrorMessage(error, 'registration', content)

      }

      form.setFieldError('code', message)
      form.setSubmitting(false)
    }
  }

  return (
    <SafeAreaView style={styles.container}>
      <KeyboardAvoidingView style={styles.content}>
        <View style={styles.logo}>
          <Image
            source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
            //height={styles.logoStyle.height} width={200} alignSelf={"center"}
            style={styles.logoImage}
          />
          {/* <CompanyIcon color={colors.white} height={styles.logoStyle.height} width={200} alignSelf={"center"} /> */}
        </View>
        <Title {...theme.title}>{content.verify_number.title}</Title>

        <Space height={24} />

        <Description {...theme.description}>
          {content.verify_number.instructions}
        </Description>

        <Space height={24} />

        <TextInputExtended
          label={content.verify_number.verificationCodeLabel}
          value={formik.values.code}
          placeholder={
            content.verify_number.verificationCodePlaceholder
          }
          {...Platform.select({
            web: { autoComplete: 'one-time-code' },
            ios: { textContentType: 'oneTimeCode' }
          })}
          onChangeText={formik.handleChange('code')}
          onBlur={formik.handleBlur('code')}
          footer={
            <Anchor
              style={styles.inputFooter}
              onPress={() => handleResendCode(formik.values, formik)}
              title={
                resendingCode
                  ? content.forgotten_password_auth.resendLabelActive :
                  content.forgotten_password_auth.resendLabel
              }
              {...testID('SignUpVerifyOTPResend')}
            />
          }
          error={formik.touched.code && formik.errors.code}
          {...theme.textInput}
          returnKeyType="go"
          onSubmitEditing={formik.handleSubmit}
          {...testID('SignUpVerifyOTP')}
        />

        <Space height={12} />

        <Button
          title={
            formik.isSubmitting
              ? content.verify_number.inProgress
              : content.verify_number.action
          }
          disabled={!formik.dirty || !formik.isValid || formik.isSubmitting}
          onPress={formik.handleSubmit}
          {...theme.button}
          titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
          disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white + 45 }}
          {...testID('SignUpVerifyOTPSubmit')}
        />
        <ReturnFooter
          cancelStyle={styles.cancelStyle}
          title={content.common.cancel}
          onPress={() => navigation.goBack()}
        />

      </KeyboardAvoidingView>

    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: backgroundColors.darkCharcoal,
    //alignItems: 'center',
    //width: '100%'
    ...Platform.select({
      web: {
        alignItems: 'center'
      }
    })
  },
  content: {
    flex: 1,
    ...adaptive.wrapperPadding,
    maxWidth: 600,
    width: '100%'
  },
  description: {
    textAlign: 'center'
  },
  inputFooter: {
    color: colors.white
  },
  cancelStyle: {
    color: colors.white
  },
  logo: {
    alignSelf: "center"
  },
  logoStyle: {
    ...adaptive.guruSize
  },
  logoImage: {
    height: 45,
    width: 45,
    position: 'relative',
    alignSelf: 'center',
    width: 200,
    ...adaptive.guruSize
  }
})
